import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SiteLaunchService } from '../services/site-launch.service';

@Injectable({
  providedIn: 'root'
})
export class SiteLaunchGuard implements CanActivate {

  constructor(private launchService: SiteLaunchService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.launchService.checkPreLaunchStatus().pipe(
      map(isPreLaunch => {
        if (isPreLaunch) {
          // Prevent navigation and show the modal
          this.launchService.showModal();
          return false;
        }
        
        // Launch date passed, allow navigation
        return true;
      })
    );
  }
}
